class InstaFeed extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initInstaFeed();
    }


    initInstaFeed() {
        //  init insta-feed__swiper 
        const swiper = new Swiper('.insta-feed__swiper', {
            slidesPerView: "auto",
            centeredSlides: true,
            initialSlide: 2,
            loop: true, // si tu utilises le mode loop

        });
    }
}

customElements.define('insta-feed', InstaFeed);